var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 50,
    viewBox: "0 0 24 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0 0H16C20.4183 0 24 3.58172 24 8V42C24 46.4183 20.4183 50 16 50H0V0Z",
    fill: "#040F1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21L10.48 24.53L14 28.06",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoLeftArrow);
export default __webpack_public_path__ + "static/media/trvto_left-arrow.585f311802c9e6558bdb9bf416c91e04.svg";
export { ForwardRef as ReactComponent };